import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Navigation = ({ isScrolled }) => {
    const [isOpen, setIsOpen] = useState(false);

    const navItems = [
        { title: 'HOME', path: '/' },
        { title: 'SERVICES', path: '/services' },
        { title: 'PRACTICE AREA', path: '/practice-areas' },
        { title: 'BLOG', path: '/blog' },
        { title: 'FAQS', path: '/faqs' },
        { title: 'CONTACT', path: '/contact' },
    ];

    return (
        <nav className={`py-4 ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
            <div className="flex justify-between items-center">
                <a href="/" className="text-2xl font-bold">
                    KHURRAM ADVOCATE
                </a>

                {/* Desktop Navigation */}
                <div className="hidden lg:flex items-center space-x-8">
                    {navItems.map((item) => (
                        <a
                            key={item.title}
                            href={item.path}
                            className="hover:text-primary transition-colors"
                        >
                            {item.title}
                        </a>
                    ))}
                </div>

                {/* Mobile Menu Button */}
                <button
                    className="lg:hidden"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                </button>
            </div>

            {/* Mobile Navigation */}
            {isOpen && (
                <div className="lg:hidden absolute top-full left-0 right-0 bg-white shadow-md py-4">
                    {navItems.map((item) => (
                        <a
                            key={item.title}
                            href={item.path}
                            className="block px-4 py-2 text-gray-900 hover:bg-gray-100"
                            onClick={() => setIsOpen(false)}
                        >
                            {item.title}
                        </a>
                    ))}
                </div>
            )}
        </nav>
    );
};

export default Navigation;